import { FC, useState } from 'react'
import { Box, Typography } from '@mui/material'
import {
  UnfoldMore as UnfoldMoreIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material'
import { styled } from '@mui/material/styles'

const HeaderText = styled(Typography)(({ theme }) => ({
  color: '#505470',
  fontFamily: 'Gabarito',
  fontWeight: 700,
  fontSize: '14px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}))

const HeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.8,
  },
  '& .MuiSvgIcon-root': {
    color: '#505470',
    fontSize: '18px',
  },
})

interface SortHeaderProps {
  label: string
  field: string
  currentSort?: {
    field: string
    direction: 'asc' | 'desc'
  }
  onSort: (sort: string) => void
  sortable?: boolean
  handleSort: (field: string, direction: 'asc' | 'desc') => void
}

export const SortHeader: FC<SortHeaderProps> = ({
  label,
  field,
  currentSort = { field: 'id', direction: 'asc' },
  onSort,
  sortable = false,
  handleSort,
}) => {
  const [direction, setDirection] = useState('asc')

  // const handleClick = () => {
  //   const isSameField = currentSort.field === field
  //   let currentDirection = direction === 'asc' ? 'desc' : 'asc'
  //   setDirection(prev => prev === "asc" ? "desc" : "asc");

  //   // const newDirection =
  //   //   isSameField && currentDirection === 'asc' ? 'desc' : 'asc'

  //   console.log("curr direction ", currentDirection)

  //   handleSort(field, currentDirection)
  // }
  const handleClick = () => {
    setDirection((prev) => {
      const newDirection = prev === 'asc' ? 'desc' : 'asc'
      handleSort(field, newDirection)
      console.log('sort', newDirection)
      return newDirection
    })
  }

  const getSortIcon = () => {
    if (!currentSort || currentSort.field !== field) {
      return <UnfoldMoreIcon />
    }
    return currentSort.direction === 'asc' ? (
      <ExpandLessIcon />
    ) : (
      <ExpandMoreIcon />
    )
  }

  if (!sortable) return <HeaderText>{label}</HeaderText>

  return (
    <HeaderBox onClick={handleClick}>
      <HeaderText>{label}</HeaderText>
      {getSortIcon()}
    </HeaderBox>
  )
}

export default SortHeader
